import { Phone, MessageCircle, Clock } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { CLINIC } from "@/data/site";
import { doCall, doWhatsApp } from "@/lib/actions";

export const CallPrompt = ({ location = "call_prompt" }) => (
  <section className="py-10 lg:py-14">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div data-testid="call-prompt" className="rounded-[var(--cdt-radius-lg)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-md)] p-6 lg:p-8 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 rounded-full bg-[rgba(15,92,90,0.08)] px-3 py-1 text-xs font-semibold text-[var(--cdt-primary)]">
              <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--cdt-primary)] opacity-60" /><span className="relative inline-flex rounded-full h-2 w-2 bg-[var(--cdt-primary)]" /></span>
              We're here to help
            </div>
            <h2 className="font-display text-2xl md:text-3xl mt-3 text-[var(--cdt-text)]">Prefer to talk? Call us now</h2>
            <p className="mt-2 text-sm md:text-base text-[var(--cdt-muted)] leading-7">Speak directly with our team for quick answers, honest guidance, or to book your visit. No call centres — just caring people.</p>
            <p className="mt-2 inline-flex items-center gap-1.5 text-xs text-[var(--cdt-muted)]"><Clock className="h-3.5 w-3.5" /> {CLINIC.hours[0].time} &amp; {CLINIC.hours[1].time} · {CLINIC.hoursNote}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 lg:flex-col xl:flex-row">
            <button onClick={() => doCall(CLINIC.phoneHref, location)} data-testid="call-prompt-call" className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-[var(--cdt-radius-sm)] bg-[var(--cdt-primary)] text-white font-semibold hover:bg-[var(--cdt-primary-2)] transition-colors whitespace-nowrap">
              <Phone className="h-4 w-4" /> {CLINIC.phone}
            </button>
            <button onClick={() => doWhatsApp(CLINIC.whatsappHref, location)} data-testid="call-prompt-whatsapp" className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-[var(--cdt-radius-sm)] border border-[color:var(--cdt-border)] text-[var(--cdt-text)] font-semibold hover:bg-[var(--cdt-surface-2)] transition-colors whitespace-nowrap">
              <MessageCircle className="h-4 w-4 text-[#25D366]" /> WhatsApp us
            </button>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
